import { DataStorage } from "../../imports";
import { checkMultipleCanvas } from "./threekitCreators";
import { uploadImage } from "./fabricCreators";

export function getFile(state) {
  const files = {};
  // turn set of pointers into set of files - for multiple canvases
  Object.keys(state.files.files).forEach((key) => {
    files[key] = DataStorage.find(state.files.files[key]);
  });
  // turn pointer into file - for single canvas
  const file = DataStorage.find(state.files.file);
  return { file, files };
}

// action creators

export function setFile(file) {
  if (!file) {
    return;
  }
  return (dispatch, getState) => {
    const node = getState().playerState.currentNode;
    const params = new URL(location.href).searchParams;
    const checkImage = params.get('imageUpload');
    console.log(getState().playerState.currentNode)
    console.log(getState().playerState)
    console.log(getState())
    
    let fileExtension = file.name.split(".")[file.name.split(".").length - 1];
    if (file.type.includes("heic") || fileExtension == "heic") {
      const message = "Selected image type is not supported. Please convert to another image type like .png or .jpeg.";
      dispatch({ type: "fabric/setError", payload: { active: true, message } });
      return;
    }
    const filePointer = DataStorage.create(file);
    document.querySelector("#threekit-fileupload").value = "";
    dispatch({ type: "file/saveFilePointer", payload: { filePointer, node } });
    dispatch(uploadImage(node));
  };
}

export function getCurrentFile(state, node) {
  const isMultipleCanvas = checkMultipleCanvas(state);
  const { file, files } = getFile(state);
  const currentNode = node || state.playerState.currentNode;
  if (isMultipleCanvas) {
    return files[currentNode];
  } else {
    return file;
  }
}
